import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeBetrieblicheDatenUniversalProps {
    standortSelected: any;
    entity: string;
}

export class DateneingabeBetrieblicheDatenUniversal extends React.Component<DateneingabeBetrieblicheDatenUniversalProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    preFilter (data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (+item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={this.props.entity}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                validateField={this.validateField}
                preFilterFunction={this.preFilter}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_BETRIEBSDATEN)}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(this.props.entity, key, value, data, onValueChange);
    }
}
